export { useCookie } from './useCookie';
export { readCookie, readCookies } from './readCookie';
export { writeCookie } from './writeCookie';
export { canWriteCookieCategory } from './categories';
//# sourceMappingURL=index.js.map
// @zapier/cookies@1.0.2 (aeccc3fd4)
